<template>
  <div class="my-machine-images">
    <div v-if="mainImageSrc" class="my-machine-images__main-image">
      <img :src="`${mainImageSrc}`" :alt="`${tStatic('machineImage')}`">
      <button aria-label="Enlarge image" class="my-machine-images__enlarge" @click="triggerModal"></button>
    </div>
    <div v-else class="my-machine-images__no-image">
      <oie-base-icon icon="image-icon" size="l"></oie-base-icon>
    </div>
    <div v-if="sortedImages.length > 1" class="my-machine-images__thumbs">
      <button
        v-for="(img, i) in sortedImages"
        :key="img.imageId"
        aria-label="Click to switch image display"
        @click="switchMainImage(i)">
        <img
          :src="`${img.url}?preset=ProductThumb`"
          :alt="`${tStatic('machineImage')}`">
      </button>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  props: {
    images: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      displayIndex: 0
    }
  },
  computed: {
    sortedImages() {
      return _.orderBy(this.images, ['type'], ['desc'])
    },
    mainImageSrc() {
      return this.sortedImages[this.displayIndex] && this.sortedImages[this.displayIndex].url
    }
  },
  methods: {
    switchMainImage(index) {
      this.displayIndex = index
    },
    triggerModal() {
      this.publish('modal.show.image-inspector', { images: this.sortedImages, displayIndex: this.displayIndex })
    }
  }
}
</script>

<style lang="scss">
.my-machine-images__main-image {
  position: relative;
  height: 200px;
  width: 300px;
  padding: measure(quarter);
  border: 1px solid color(gray-4);
  background-color: color(black);
  margin-bottom: measure(quarter);
}

.my-machine-images__no-image {
  height: 200px;
  width: 300px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: color(gray-5);

  svg {
    opacity: 0.6;
  }
}

.my-machine-images__enlarge {
  @include reset-button;
}

.my-machine-images__enlarge::after {
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}

.my-machine-images__main-image img{
  height: 100%;
  width: 100%;
  object-fit: contain;
}

.my-machine-images__thumbs {
  display: flex;
  gap: measure(quarter);
  flex-wrap: wrap;
}

.my-machine-images__thumbs button{
  @include reset-button;
  border: 1px solid color(gray-4);
}
</style>
